import React from "react";
import PolicyLayout from "./PolicyLayout";
import "../css/policy.scss";

const sections = [
  {
    id: "return-window",
    title: "Change-of-mind return window",
    body: [
      "Request a return within 30 days after the recorded delivery date. If an order arrives in separate parcels, the period for each item begins when that item is delivered.",
      "This voluntary return window is separate from any longer cancellation, faulty-goods or consumer-guarantee right that cannot lawfully be limited.",
    ],
  },
  {
    id: "condition",
    title: "Return condition",
    items: [
      "The item must be unworn except for a careful indoor try-on, unwashed, unaltered and undamaged after delivery.",
      "Original tags, hygiene seals and protective packaging must remain attached where supplied.",
      "The item must be free from cosmetics, fragrance, smoke, pet hair and other marks or odours.",
      "Proof of purchase, such as the order confirmation or another reliable transaction record, is required.",
    ],
  },
  {
    id: "exclusions",
    title: "Change-of-mind exclusions",
    items: [
      "Products labelled FINAL SALE before purchase.",
      "Personalised, monogrammed or customer-altered products.",
      "Gift cards or store-credit instruments, if offered, except where law requires otherwise.",
      "A hygiene-sensitive product after its protective seal has been removed.",
      "An item bought from another retailer, which must be returned to the original seller.",
    ],
    body: [
      "These exclusions do not remove a remedy for a faulty, unsafe, incorrect, damaged or materially misdescribed product, or another mandatory right.",
    ],
    links: [
      { to: "/sale-policy", label: "Sale & promotions" },
      { to: "/consumer-guarantees", label: "Consumer guarantees" },
    ],
  },
  {
    id: "start-return",
    title: "How to start a return",
    body: [
      "Email service@nartvmora.site with the order reference, the item and the reason for return. Wait for return instructions and the confirmed return destination before sending the parcel; an unapproved address may delay or prevent processing.",
      "Pack the item securely and remove or cover old carrier labels. Include the requested return reference without placing tape or a label directly on product packaging.",
    ],
    links: [{ to: "/contact", label: "Start a return request" }],
  },
  {
    id: "return-postage",
    title: "Return postage and responsibility",
    body: [
      "For a voluntary change-of-mind return, the customer pays return postage unless a published offer says otherwise. Use a trackable service and keep the lodgement receipt until the return is completed.",
      "nartvmora will cover reasonable return costs where an item is confirmed faulty, incorrect, damaged in transit or another applicable right requires it. Responsibility for a customer-arranged return remains with the sender until it reaches the confirmed return destination, except where law provides otherwise.",
    ],
  },
  {
    id: "assessment",
    title: "Assessment",
    body: [
      "Returns are normally inspected within five business days after arrival. We may request more information if the item, order reference or reason cannot be identified.",
      "If a change-of-mind return does not meet the published conditions, we will explain the decision and discuss lawful options, which may include returning the item to the customer at their cost. Mandatory consumer remedies are assessed separately.",
    ],
  },
  {
    id: "refunds",
    title: "Refunds",
    body: [
      "An approved refund is submitted to the original payment method in USD for the amount actually paid for the returned item, after any lawful promotion recalculation. Original delivery charges are not normally refunded for a partial or change-of-mind return.",
      "The payment provider or bank may take a further three to ten business days to display the credit. We cannot control issuer processing time or exchange-rate differences.",
    ],
    links: [{ to: "/payments", label: "Payments & billing" }],
  },
  {
    id: "promotions",
    title: "Discounts, bundles and gifts",
    body: [
      "Refunds reflect the price allocated to each item after discounts. If a return causes the retained order to fall below a promotion threshold, the refund may be recalculated under the disclosed offer terms.",
      "A promotional gift supplied because of a qualifying purchase should be returned with that purchase if the retained order no longer qualifies. If it is not returned, its disclosed value may be deducted only where that condition was clear and lawful.",
    ],
  },
  {
    id: "exchanges",
    title: "Exchanges",
    body: [
      "Sizes and colours are not reserved for direct exchange. For a change of size or style, request a return and place a new order. A faulty-product remedy may include replacement where appropriate and available.",
    ],
  },
  {
    id: "faults",
    title: "Faulty, incorrect or damaged items",
    body: [
      "Report the issue promptly with the order reference, a description and clear photographs. Keep the item and packaging until we confirm what is needed for assessment.",
      "Expected denim fading, ordinary wear, accidental damage, alteration or care contrary to the garment label is not normally a manufacturing fault. Each claim will be assessed under the mandatory law that applies.",
    ],
    links: [
      { to: "/consumer-guarantees", label: "Consumer guarantees" },
      { to: "/shipping", label: "Shipping & delivery" },
    ],
  },
];

function Returns() {
  return (
    <PolicyLayout
      title="Returns & Refunds"
      intro="Eligibility, return steps, assessment, refunds and remedies for product issues."
      updated="Effective 16 October 2026"
      sections={sections}
      action={{ to: "/contact", label: "Start a return" }}
    />
  );
}

export default Returns;
